import bffAPI from 'services/api/bff';

export async function login(username, password) {
  return bffAPI.post(`/authentication/login`, { username, password }).then(({ data }) => data);
}

export async function resetPassword(email) {
  return bffAPI.post(`/authentication/recover-password`, { email }).then(({ data }) => data);
}
